
<div class="row">
    <div class="col-lg-12">
        <div class="primeng-datatable-container products">
            <p-table #dataTable
                     [value]="primengTableHelper.records"
                     rows="{{primengTableHelper.defaultRecordsCountPerPage}}"
                     [responsive]="primengTableHelper.isResponsive"
                     [resizableColumns]="primengTableHelper.resizableColumns">
                <ng-template pTemplate="header">
                    <tr>
                        <th style="width: 10em">
                            <span translation="Axilla.OrderGuide.Article.Picture" source="Axilla">
                            </span>
                        </th>
                        <th pSortableColumn="code" style="width: 10em">
                            <span translation="Axilla.OrderGuide.Article.Code" source="Axilla">
                            </span>
                            <p-sortIcon field="code"></p-sortIcon>
                        </th>
                        <th pSortableColumn="title">
                            <span translation="Axilla.OrderGuide.Article.Title" source="Axilla">
                            </span>
                            <p-sortIcon field="title"></p-sortIcon>
                        </th>

                        <th pSortableColumn="description">
                            <span translation="Axilla.OrderGuide.Article.Description" source="Axilla">
                            </span>
                            <p-sortIcon field="description"></p-sortIcon>
                        </th>
                        <th style="width: 5em; text-align: right">
                            <span translation="Axilla.OrderGuide.Article.ItemAmount" source="Axilla">
                            </span>
                        </th>
                        <th style="width: 7em">
                            <span translation="Axilla.OrderGuide.Article.ItemPackage" source="Axilla">
                            </span>
                        </th>
                        <th pSortableColumn="price" style="width: 6em">
                            <span translation="Axilla.OrderGuide.Article.Price" source="Axilla">
                            </span>
                            <p-sortIcon field="price"></p-sortIcon>
                        </th>
                        <th style="width: 8em;">
                            <span translation="Axilla.OrderGuide.Article.Count" source="Axilla">
                            </span>
                        </th>

                        <th style="width: 6em">
                            <span translation="Axilla.Actions" source="Axilla">
                            </span>
                        </th>
                    </tr>
                </ng-template>

                <ng-template pTemplate="body" let-record="$implicit">
                    <tr>
                        <td>
                            <app-image-container [articleId]="record.code" [height]="'68'"></app-image-container>
                        </td>
                        <td>
                            {{record.code}}
                        </td>
                        <td>
                            {{record.title}}
                        </td>

                        <td>
                            <div class="td-overflow">
                                {{record.description}}
                            </div>
                        </td>
                        <td style="text-align: right">
                            {{record.amount}}
                        </td>
                        <td>
                            <span *ngIf="record.amount == 1" translation="Axilla.OrderGuide.Article.AmountPce" source="Axilla">
                            </span>
                            <span *ngIf="record.amount > 1" translation="Axilla.OrderGuide.Article.AmountBox" source="Axilla">
                            </span>
                        </td>
                        <td>
                            {{record.price | currency:getCurrency(record.currency):'symbol-narrow':'.2-2'}}
                        </td>
                        <td style="width: 150px">
                            <p-spinner [(ngModel)]="record.quantity"
                                       [step]="1"
                                       [min]="0"
                                       OnlyNumber="true"
                                       inputStyleClass="item-quantity"
                                       [formatInput]="true"
                                       thousandSeparator=","
                                       decimalSeparator="."
                                       (onBlur)="confirmChangingItemCount(record)"></p-spinner>

                        </td>
                        <td>
                            <div class="d-flex justify-content-around">
                                <button class="btn btn-success"
                                        (click)="remove(record)">
                                    <i class="fas fa-trash-alt"></i>
                                </button>
                            </div>
                        </td>
                    </tr>
                </ng-template>
            </p-table>

            <div class="primeng-no-data" *ngIf="primengTableHelper.totalRecordsCount == 0 && !primengTableHelper.isLoading && basket.length == 0">
                <span translation="Axilla.NoData" source="Axilla"></span>
            </div>
            <div class="primeng-no-data" *ngIf="primengTableHelper.isLoading">
                <span translation="Axilla.LoadingData" source="Axilla"></span>
            </div>
        </div>
    </div>
    <div class="spinner-container" *ngIf="isLoading">
        <p-progressSpinner></p-progressSpinner>
    </div>
</div>
